// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import { Row, Col, Button, Input, Loading, Dialog, Dropdown, DropdownMenu, DropdownItem, Checkbox, CheckboxGroup } from 'element-ui'
import './assets/element-#0AAC50/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/base.css' /*引入公共样式*/
import VideoPlayer from 'vue-video-player'
import axios from 'axios'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import Avatar from './im/avatar.vue'
import store from './vuex/store'
// import tim from './tim'
import TIM from 'tim-js-sdk'
import COSSDK from 'cos-js-sdk-v5'
import TWebLive from 'tweblive'
import VueClipboard from 'vue-clipboard2'
import './assets/icon/iconfont.css'
import './assets/icon/tim.css'
// import trtcCalling from './trtc-calling'
import TRTCCalling from 'trtc-calling-js'
// window.tim = tim
window.TIM = TIM
window.COSSDK = COSSDK
window.TRTCCalling = TRTCCalling
// window.trtcCalling = trtcCalling
window.store = store
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
// Vue.prototype.tim = tim
Vue.prototype.TIM = TIM
Vue.prototype.COSSDK = COSSDK
Vue.prototype.TWebLive = TWebLive
// Vue.prototype.trtcCalling = trtcCalling
Vue.prototype.TRTCCalling = TRTCCalling
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(VueClipboard)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.component('avatar', Avatar)


const hls =require("videojs-contrib-hls")
Vue.use(VideoPlayer)
Vue.use(hls)
Vue.config.productionTip = false
Vue.use(ElementUI)

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,
{
     error:'./static/error.png',
    // loading:'./static/loading.png'
},
)

//自定义
var axios2 = axios.create({
  baseURL:'',
  timeout:5000,
  headers:{"Content-Type":"multipart/form-data"}
});

Vue.prototype.axios = axios;
Vue.prototype.axios2=axios2;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: function (createElement) {
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
    return createElement(App);
  }
})



// WEBPACK FOOTER //
// ./src/main.js